module.exports = __webpack_public_path__ + "static/img/up-t.ca4eb13d.png";